
































































































import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import IntegerInput from 'components/IntegerInput.vue'
import AnswersEditor from 'components/presenter/item/topic/editor/AnswersEditor.vue'

@Component({
  components: {
    FormSlide,
    IntegerInput,
    AnswersEditor
  }
})
export default class ItemTopicSlidesEditorFormYesNo extends Mixins(MixinForm) {
  correctAnswers = new Set<string>()

  @Watch('correct', { immediate: true })
  setCorrectAnswers (correct: string[]){
    this.correctAnswers = new Set(correct)
  }

  setCorrectAnswer (answer: Json) {
    if (this.correctAnswers.has(answer.id)) {
      this.correctAnswers.delete(answer.id)
    } else {
      this.correctAnswers.add(answer.id)
    }
    this.correctAnswers = new Set(this.correctAnswers)
    const correct = this.correctAnswers.size > 0 ? [...this.correctAnswers] : null
    this.setCorrect(correct)
  }
}
